import React from "react";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { viewconciliationreport,updatebankstatementamount} from "../../../../components/CommonSection/apiresources";
import { GetCookie } from "../../../../components/CommonSection/Cookie/Session";
import { makeRequestWithSpinner } from "../../../../Utilities/client";
import { useSpinnerContext } from "../../../../Utilities/SpinnerContext";
import "../../../../components/Dashboard/Dashboard-agent/AgentList.css";
import { ActionStatus } from "../../../../Utilities/enum";
import SubNav from "../../../navbar/subNav";
import { message} from 'antd';
import moment from "moment";
import ToastAlert from "../../../../components/CommonSection/ToastAlert/ToastAlert";
import CustomModal from "../../../input-components/Modal";
import TextBox from "../../../input-components/textbox";
import "../Reconciliations/reconciliations.css";

const viewReconciliations = () => {
    const [reconciliationsDetails, setReconciliationsDetails] = useState([]);
    const [userId, setUserId] = useState("");
    const [agencyID, setAgencyId] = useState("");
    const { showSpinner, hideSpinner } = useSpinnerContext();
    const [openBankStatement,setOpenBankStatement] = useState(false)
    const [bankStatementDate, setBankStatementDate] = useState("");
    const [bankStatementAmount, setBankStatementAmount] = useState("");

    const ToastRef = useRef();
    var url = new URL(window.location.href);
    var date = url.searchParams.get("date");

    useEffect(() => {
        const retrieveData = async () => {
            try {
                const userData = GetCookie("@UserData");
                if (userData) {
                    const parsedData = JSON.parse(userData);
                    setUserId(parsedData.userId);
                    setAgencyId(parsedData.agencyID);
                }
            } catch (error) {
                console.error("Error retrieving data from AsyncStorage:", error);
            }
        };
        retrieveData();
    }, [userId]);

    useEffect(() => {
        if (userId) getReconciliationDetails(date);
    }, [userId]);

     
    const getReconciliationDetails = (date) => {
        const baseUrl = viewconciliationreport;

        const cleanDate = moment(date, moment.ISO_8601).isValid()
        ? moment(date).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");

        let data = {
            AgencyId: agencyID,
            Month:cleanDate
        }
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                   
                    setReconciliationsDetails(response.object);
                } else {
                    message.error(response.message)
                    alert(`Message: ${response.message}`);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };
     
    const formatCurrency = (value) =>
        (value || 0).toLocaleString("en-US", {
          style: "currency",
          currency: "USD"
        });
    
      const currentDate = moment().format("D MMM YYYY");

      const decodedDate = decodeURIComponent(date || "");
      const safeDate = decodedDate.split("T")[0]; // Gets "2025-04-11"
      const formattedMonthYear = moment(safeDate, "YYYY-MM-DD").format("MMMM YYYY");

      const handleBankStatement = () => {
        const details = reconciliationsDetails.bankAccountDetails;
        setBankStatementDate(moment(details?.date).format("YYYY-MM-DD") || "");
        setBankStatementAmount(details?.bankStatementBalance?.toString() || "");
        setOpenBankStatement(true)
      }

      const closeBankStatement = () => {
        setOpenBankStatement(false)
      }
      
      const submitBankDetails = () => {
        const baseUrl = updatebankstatementamount;

        const momentDate = moment(bankStatementDate, "YYYY-MM-DD").utcOffset("+05:30");
        const formattedDate = momentDate.format();

        let data = {
            AgencyId: agencyID,
            Amount: bankStatementAmount,
            Date: formattedDate,
            Month: formattedDate
        }
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    ToastRef.current.notify(["success", response.message]);
                   setOpenBankStatement(false);
                   getReconciliationDetails(date)
                } else {
                    message.error(response.message)
                    alert(`Message: ${response.message}`);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    return (
        <div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 changedateantdstyle">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 daily-date-style">
                    <SubNav   title={moment(safeDate, "YYYY-MM-DD").isValid() ? `${formattedMonthYear} Reconciliation ` : "Invalid date"} goback={true} extraData={true} />
                    <div className="material-work-desk-new bg-white m-3 p-3">
                    <ToastAlert ref={ToastRef} />
                    <h5 className="mb-3" style={{color:"#1f6785"}}>Bank Reconciliation Report</h5>

                        {reconciliationsDetails ? (
                            <>
                                {/* Bank Account Section */}
                                <div className="reconciliation-card">
                                    <div className="reconciliation-header">Bank Account</div>
                                    <div className="reconciliation-row">
                                        <div className="reconciliation-label">
                                            <a onClick={handleBankStatement} href="#">Bank Statement Balance</a> as at:{" "}
                                            <strong>{moment(reconciliationsDetails.bankAccountDetails?.date).format("dddd, D MMMM YYYY")}</strong>
                                        </div>
                                        <div className="reconciliation-value">
                                            {formatCurrency(reconciliationsDetails.bankAccountDetails?.bankStatementBalance)}
                                        </div>
                                    </div>

                                    <div className="reconciliation-row"><div className="reconciliation-label">Add: unreconciled deposits</div><div className="reconciliation-value">+ {formatCurrency(reconciliationsDetails.bankAccountDetails?.unreconciledDeposits)}</div></div>
                                    <div className="reconciliation-row"><div className="reconciliation-label">Less: unreconciled withdrawals</div><div className="reconciliation-value">− {formatCurrency(reconciliationsDetails.bankAccountDetails?.unreconciledWithdrawals)}</div></div>
                                    <div className="reconciliation-row"><div className="reconciliation-label">Add: adjustment</div><div className="reconciliation-value">+ {formatCurrency(reconciliationsDetails.bankAccountDetails?.adjustments)}</div></div>
                                    <div className="reconciliation-row"><div className="reconciliation-label">Add: cash not banked</div><div className="reconciliation-value">+ {formatCurrency(reconciliationsDetails.bankAccountDetails?.cashNotBanked)}</div></div>
                                    <div className="reconciliation-row"><div className="reconciliation-label">Less: withdrawals not processed</div><div className="reconciliation-value">− {formatCurrency(reconciliationsDetails.bankAccountDetails?.withdrawalsnotprocessed)}</div></div>

                                    <div className="reconciliation-balance">
                                        <div>Reconciled bank statement balance</div>
                                        <div>
                                            {
                                                formatCurrency(
                                                    (reconciliationsDetails.bankAccountDetails?.bankStatementBalance || 0) +
                                                    (reconciliationsDetails.bankAccountDetails?.unreconciledDeposits || 0) -
                                                    (reconciliationsDetails.bankAccountDetails?.unreconciledWithdrawals || 0) +
                                                    (reconciliationsDetails.bankAccountDetails?.adjustments || 0) +
                                                    (reconciliationsDetails.bankAccountDetails?.cashNotBanked || 0) -
                                                    (reconciliationsDetails.bankAccountDetails?.withdrawalsnotprocessed || 0)
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>

                                {/* Cashbook Section */}
                                <div className="reconciliation-card">
                                    <div className="reconciliation-header">Cashbook</div>
                                    <div className="reconciliation-row">
                                        <div className="reconciliation-label">Balance brought forward from: {moment(reconciliationsDetails.cashbook?.date).startOf("month").format("D MMM YYYY")}</div>
                                        <div className="reconciliation-value">{formatCurrency(reconciliationsDetails.cashbook?.openingBalance)}</div>
                                    </div>
                                    <div className="reconciliation-row"><div className="reconciliation-label">Add: new receipts</div><div className="reconciliation-value">+ {formatCurrency(reconciliationsDetails.cashbook?.newReceipts)}</div></div>
                                    <div className="reconciliation-row"><div className="reconciliation-label">Less: new withdrawals</div><div className="reconciliation-value">− {formatCurrency(reconciliationsDetails.cashbook?.newWithdrawals)}</div></div>
                                    <div className="reconciliation-balance">
                                        <div>Balance as at {currentDate}</div>
                                        <div>{formatCurrency(reconciliationsDetails.cashbook?.cashbookBalance)}</div>
                                    </div>
                                </div>

                                {/* Folio Balances Section */}
                                <div className="reconciliation-card">
                                    <div className="reconciliation-header">Folio Balances</div>
                                    <div className="reconciliation-row">
                                        <div className="reconciliation-label">Balance as at {currentDate}</div>
                                        <div className="reconciliation-value">{formatCurrency(reconciliationsDetails.folioBalance?.folioBalance)}</div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div>Loading reconciliation details...</div>
                        )}

                    </div>
                    <CustomModal title={"Bank Statement Balance"} width={600} closable={closeBankStatement} visible={openBankStatement} onCancel={closeBankStatement}
                        modalData={
                            <div className="p-3" style={{ marginTop: '-30px' }}>
                                <TextBox colVal={12} value={bankStatementDate} name="bankStatementDate" label={"Date"} onChange={(e) => setBankStatementDate(e.target.value)}  />
                                <TextBox colVal={12} value={bankStatementAmount} name="bankStatementAmount" label={"Bank Balance"} onChange={(e) => setBankStatementAmount(e.target.value)}  />
                            </div>
                        }
                        footer={[
                            <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
                            <button style={{background:"#348fb2", color:"white"}} onClick={submitBankDetails} className="btn">
                                Submit
                            </button>
                        </div>
                        ]} 
                    />
                </div>
            </div>
        </div>
    );
};

export default viewReconciliations;
